import { render, staticRenderFns } from "./EnvelopeDetails.vue?vue&type=template&id=3df43986&scoped=true"
import script from "./EnvelopeDetails.vue?vue&type=script&lang=js"
export * from "./EnvelopeDetails.vue?vue&type=script&lang=js"
import style0 from "./EnvelopeDetails.vue?vue&type=style&index=0&id=3df43986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df43986",
  null
  
)

export default component.exports